<template>
  <div class="languages">
    <div
      class="circle"
      :ref="lang.label"
      :class="{ selected: innerLanguage === lang.lang }"
      v-for="lang in langTypes"
      :key="lang.label"
      @click="selectLanguage(lang)"
      :style="{ '--color': secondColor }"
    >
      <div>{{ lang.label }}</div>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    language: String,
    defaultLang: String,
    otherLang: {
      type: Array,
      default: () => []
    },
    secondColor: {
      type: String,
      default: "#54ca7e"
    }
  },
  model: {
    prop: "language",
    event: "input"
  },
  computed: {
    innerLanguage: {
      get() {
        return this.language;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    langTypes() {
      if (!this.defaultLang) {
        return;
      }
      const langs = [];
      langs.push({ lang: this.defaultLang, label: this.defaultLang.split("_")[0].toUpperCase() });
      this.otherLang.forEach((lang) => langs.push({ lang: lang, label: lang.split("_")[0].toUpperCase() }));
      return langs;
    }
  },
  methods: {
    selectLanguage(object) {
      this.innerLanguage = object.lang;
    }
  }
};
</script>
<style scoped>
.languages {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 20px;
}
.circle {
  border: 1px solid #909090;
  border-radius: 100%;
  color: #909090;
  cursor: pointer;
  width: 30px;
  height: 30px;
  font-weight: 300;
  font-size: 14px;
  margin-right: 10px;
}
.circle div {
  padding-top: 7px;
  padding-left: 6px;
}
.selected {
  color: var(--color, #54ca7e);
  border-color: var(--color, #54ca7e);
}
.circle:hover {
  color: var(--color, #54ca7e);
  border-color: var(--color, #54ca7e);
}
</style>
